



































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Category } from '@/models/category.model';

@Component
export default class DropDownInput extends Vue{
    @Prop() private options!: any[];
    @Prop() private dataType!: string;
    @Prop() private selectedValue!: any;
    @Prop() private hasError!:boolean;
    // @Prop() private value!: string;
    value:any = undefined;

    created(){
        this.value = this.selectedValue as number;
    }

    @Watch("selectedValue")
    selectedValueChanged(){
        this.value = this.selectedValue as number;
    }

    onChange(event: any){
        this.$emit('input', event);
    }

}
